import type { MenuDto } from "@deliveryapp/shared";

/**
 * După ce adresa a fost verificată, un meniu în care fiecare ofertă are
 * `no_vendor` aparține unui restaurant care nu livrează deloc acolo. Păstrat în
 * listă, el umple pagina cu zeci/sute de carduri gri și ascunde restaurantul de
 * la care clientul chiar poate comanda.
 *
 * Alte indisponibilități (epuizat, închis, produs oprit) rămân vizibile: sunt
 * informații despre restaurantul eligibil, nu dovada că meniul aparține altei
 * zone. Înainte de adresă păstrăm toate meniurile pentru explorare.
 */
export function menusVisibleAtAddress(menus: MenuDto[], addressResolved: boolean): MenuDto[] {
  if (!addressResolved) return menus;
  return menus.filter((menu) =>
    menu.offers.some((offer) => offer.available || offer.unavailableReason !== "no_vendor"),
  );
}
